var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.95,
    height: 22.897,
    viewBox: "0 0 25.95 22.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-240 -2560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.028,4H6.29A2.3,2.3,0,0,0,4,6.29V20.028a2.3,2.3,0,0,0,2.29,2.29H20.028a2.3,2.3,0,0,0,2.29-2.29V6.29A2.3,2.3,0,0,0,20.028,4Zm0,16.028H6.29V6.29H20.028Z",
    transform: "translate(236 2556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.159,2a9.159,9.159,0,1,0,9.159,9.159A9.162,9.162,0,0,0,11.159,2Z",
    transform: "translate(245.632 2562.579)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.8ba2290a8c64567fa84e149ec3b12924.svg";
export { ForwardRef as ReactComponent };